import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import DatePicker from 'components/ui/DatePicker';
import Spacer from 'components/ui/Spacer';
import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';

const FullWidthDatePicker = styled(DatePicker)`
  width: 100%;
`;

const oneDayFromNow = moment().add(1, 'days');

const DueDate = ({ values, errors, touched, setFieldValue }) => {
  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={`${getTranslatedString('landlordPortal.batches.schedule.processingDate')}*`}
            validateStatus={touched.post_at && errors.post_at ? 'error' : null}
            help={touched.post_at && errors.post_at}
          >
            <FullWidthDatePicker
              name="post_at"
              defaultPickerValue={moment().locale(getCurrentLocale())}
              showToday={false}
              value={values.post_at}
              onChange={value => setFieldValue('post_at', value, true)}
              placeholder="e.g. 2020-01-01"
              mobileMode="date"
              size="large"
              id="error"
              disabledDate={current => current && current < oneDayFromNow}
              minDate={oneDayFromNow}
            />
          </Form.Item>
        </Col>
      </Row>
    </Spacer>
  );
};

export default DueDate;
